export default {
    NEW: 'NEW',
    EDIT: 'EDIT',
};
